import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";

const DefenderScanTable = ({ isSidebarOpen }) => {
  const navigate = useNavigate();

  return (
    <div
      className="cloudmap-page container-fluid"
      style={{
        marginLeft: isSidebarOpen ? "0px" : "0px",
        transition: "margin-left 0.3s ease",
        paddingTop: "100px"
      }}
    >
      <div className="container mb-4">
        <div className="text-center" style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          border: 'none',
          borderRadius: '12px',
          padding: '60px 40px',
          color: 'white',
          boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
        }}>
          <h2 style={{ fontWeight: '700', marginBottom: '20px' }}>Vulnerability Scanning</h2>
          <p style={{ fontSize: '18px', marginBottom: '30px', opacity: 0.95 }}>
            Run comprehensive vulnerability scans for your Web Applications and Cloud Resources on demand
          </p>
          <div style={{ 
            backgroundColor: 'rgba(255,255,255,0.2)', 
            padding: '20px', 
            borderRadius: '8px',
            marginBottom: '30px'
          }}>
            <p style={{ fontSize: '16px', marginBottom: '10px' }}>✓ Web Application Security Testing</p>
            <p style={{ fontSize: '16px', marginBottom: '10px' }}>✓ Cloud Infrastructure Vulnerability Assessment</p>
            <p style={{ fontSize: '16px', marginBottom: '0' }}>✓ On-Demand Scanning & Detailed Reports</p>
          </div>
          <button 
            className="btn btn-light btn-lg"
            style={{ 
              fontWeight: '600',
              padding: '12px 40px',
              borderRadius: '8px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}
            onClick={() => navigate('/dashboard/pricing')}
          >
            Upgrade Your Plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default DefenderScanTable;

/* 
===========================================
ORIGINAL CODE - PRESERVED FOR FUTURE USE
===========================================

import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPlus, FaTrash, FaEdit, FaRedoAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Swal from "sweetalert2";

const DefenderScanTable = ({ isSidebarOpen }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [newTarget, setNewTarget] = useState({ urlOrIP: "" });
  const [editMode, setEditMode] = useState(false);
  const [connectedAccounts, setConnectedAccounts] = useState([]);
  const rowsPerPage = 6;

  useEffect(() => {
    const accounts = localStorage.getItem("connectedAccounts");
    setConnectedAccounts(accounts ? JSON.parse(accounts) : []);
  }, []);
  
  const handleConnectAccount = () => {
    navigate('/dashboard/connected-accounts');
  };
  
  const tableData = [
    { id: 1, status: "Complete", target: "13.40.224.221", tags: "Portal1", date: "19 Feb 2024" },
    { id: 2, status: "Error", target: "13.42.13.16", tags: "Portal6", date: "19 Feb 2024" },
    { id: 3, status: "Pending", target: "13.42.46.137", tags: "Portal3", date: "19 Feb 2024" },
    { id: 4, status: "Complete", target: "178.79.154.6", tags: "Portal4", date: "19 Feb 2024" },
    { id: 5, status: "Error", target: "18.132.68.174", tags: "Portal2", date: "20 Feb 2024" },
    { id: 6, status: "Pending", target: "35.178.177.72", tags: "Portal5", date: "19 Feb 2024" },
  ];

  const filteredData = tableData.filter((row) =>
    row.target.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handleAddTarget = () => {
    setEditMode(false);
    setNewTarget({ urlOrIP: "" });
    setShowModal(true);
  };

  const handleSaveTarget = () => {
    console.log("New Target: ", newTarget);
    setShowModal(false);
    Swal.fire("Success", `${editMode ? "Target updated" : "Target added"} successfully!`, "success");
  };

  const handleEdit = (targetId) => {
    const targetToEdit = tableData.find((row) => row.id === targetId && row.status === "Error");
    if (targetToEdit) {
      setEditMode(true);
      setNewTarget({ urlOrIP: targetToEdit.target });
      setShowModal(true);
    } else {
      Swal.fire("Info", "Only targets with status 'Error' can be edited.", "info");
    }
  };

  const handleRescan = (targetId) => {
    Swal.fire({
      title: "Confirm Rescan",
      text: `Are you sure you want to rescan target ID ${targetId}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, rescan",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Rescanning", `Target ID ${targetId} is being rescanned.`, "success");
      }
    });
  };

  const handleDelete = (targetId) => {
    Swal.fire({
      title: "Confirm Delete",
      text: `Are you sure you want to delete target ID ${targetId}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Deleted", `Target ID ${targetId} has been deleted.`, "success");
      }
    });
  };
  
  if (!connectedAccounts || connectedAccounts.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100"
        style={{
          backgroundImage: 'url("/images/blurred_image.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
        <div className="text-center text-dark p-4"
          style={{ backgroundColor: "rgba(170, 172, 242, 0.33)", borderRadius: "8px" }}>
          <h3>No Connected Accounts Found</h3>
          <p>To access this dashboard, please connect at least one account. Click the button below to get started.</p>
          <button className="btn text-white mt-3" style={{backgroundColor : '#342ead'}} onClick={handleConnectAccount}>
            Connect Account
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="cloudmap-page container-fluid"
      style={{
        marginLeft: isSidebarOpen ? "0px" : "0px",
        transition: "margin-left 0.3s ease",
      }}>
      <div className="container mb-4">
        <div className="justify-content-between align-items-center mb-4" style={{
          display: window.innerWidth <= 576 ? "inline" : "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}>
          <h3 className="fw-bold text-muted ms-2" style={{ fontWeight: "bold", fontSize: "2rem" }}>DefenderScan</h3>
          <div className="d-flex align-items-center mb-3">
            <input type="text" className="form-control me-2" placeholder="Search Target"
              value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ width: "250px" }} />
            <button className="custom-button" style={{ padding: "6px 0px" }} onClick={handleAddTarget}>
              <FaPlus className="me-2" /> Add Target
            </button>
          </div>
        </div>

        <div className="row">
          {currentRows.map((row) => (
            <div className="col-md-4 mb-4" key={row.id}>
              <div className="p-3 rounded shadow text-muted">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="card-title fw-bold" style={{ color: "#666cff" }}>{row.target}</h5>
                    <span className="badge" style={{
                        backgroundColor: row.status === "Complete" ? "#ddfbdf" : row.status === "Pending" ? "#FFF3E0" : "#FFEBEE",
                        color: row.status === "Complete" ? "#4CAF50" : row.status === "Pending" ? "#FF9800" : "#F44336",
                        fontWeight: "700",
                      }}>
                      {row.status}
                    </span>
                  </div>
                  <p className="mb-1"><strong>Tags:</strong> {row.tags}</p>
                  <p className="mb-3"><strong>Date:</strong> {row.date}</p>
                  <div className="d-flex flex-wrap gap-2 justify-content-end">
                    <button className="btn btn-sm"
                      style={{ color: "#66Db3a", border: "1px solid #66Db3a", backgroundColor: "#e7fce98b" }}
                      onMouseEnter={(e) => { e.currentTarget.style.color = "#fff"; e.currentTarget.style.backgroundColor = "#66Db3a"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.color = "#66Db3a"; e.currentTarget.style.backgroundColor = "#e7fce98b"; }}
                      onClick={() => navigate(`details/${row.id}`)}>
                      View Details
                    </button>
                    {row.status === "Error" && (
                      <button className="btn btn-sm btn-outline-secondary" onClick={() => handleEdit(row.id)}>
                        <FaEdit /> Edit
                      </button>
                    )}
                    <button className="btn btn-sm btn-outline-primary" onClick={() => handleRescan(row.id)}>
                      <FaRedoAlt /> Rescan
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(row.id)}>
                      <FaTrash /> Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-between align-items-center mt-3">
          <small>Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, filteredData.length)} of {filteredData.length} entries</small>
          <nav>
            <ul className="pagination mb-0">
              {[...Array(totalPages)].map((_, page) => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? "active" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(page + 1)}>{page + 1}</button>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {showModal && (
          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>{editMode ? "Edit Target" : "Add Target"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="mb-3">
                <label className="form-label">Enter URL or IP</label>
                <input type="text" className="form-control" value={newTarget.urlOrIP}
                  onChange={(e) => setNewTarget({ ...newTarget, urlOrIP: e.target.value })}
                  placeholder="e.g., https://example.com or 192.168.1.1" />
              </div>
              <div className="alert alert-info mt-3">
                Please enter a valid URL or IP address to initiate a Defender scan.
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
              <Button variant="primary" onClick={handleSaveTarget} disabled={!newTarget.urlOrIP}>
                {editMode ? "Start New Scan" : "Start Scan"}
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default DefenderScanTable;
*/
